module.exports = __webpack_public_path__ + "img/logo.0f083df6.png";